// Pre-launch: single-page home — bottom nav hidden (everything on /).

function BottomNav() {
	return null;
}

export default BottomNav;
